export default __webpack_public_path__ + "static/media/vehicle_passenger.97b62716.svg";